import { Pipe, PipeTransform } from '@angular/core';
import { LocalDate } from '../types/local-date.type';
import { LocalDateTime } from '../types/local-date-time.type';

@Pipe({
	name: 'displayLocalDate'
})
export class DisplayLocalDatePipe implements PipeTransform {
	transform(localDate: LocalDate | LocalDateTime | number[] | null | undefined): string | undefined {
		if (!localDate)
			return undefined;
		
		const year = localDate[0];
		const month = localDate[1];
		const day = localDate[2];
		
		return this.pad(day) + '/' + this.pad(month) + '/' + year;
	}
	
	private pad(value: number): string {
		return (value < 10 ? "0" : "") + value;
	}
}